export default {
  button: {
    _focus: {
      boxShadow: "none",
    },
  },
};
